export const rewardRuleTypesEnum = {
    SIGN_IN: { code : 1, type : "用户签到"},
    POST: { code : 2, type : "发布帖子"},
    POST_COMMENT: { code : 3, type : "发布评论"},
    POST_UPVOTE: { code : 4, type : "帖子获赞"},
    POST_COLLECTED: { code : 5, type : "帖子获收藏"},
    ATTEND_ACTIVE: { code : 6, type : "参与活动"},
    ATTEND_COURSE: { code : 7, type : "参与课程"}
}

export const rewardRuleKeyEnum = {
    UPVOTE: 'upvote', // 获赞量
    COLLECTION: 'collection' // 获收藏数
}